import React from "react";
import {default as KAMultiSelect} from "@khanacademy/react-multi-select";

const MultiSelect = props => (
  <div className={"MultiSelect-Root"}>
    <KAMultiSelect {...props}/>
  </div>
);

export default MultiSelect;